module.exports = __webpack_public_path__ + "static/media/close-black.6c2540c1.svg";